import { QuestionPlanIsUncancelable as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-uncancelable";

import { useDayTripPlanIsUncancelable } from "./hooks";

export const QuestionDayTripPlanIsUncancelable = () => {
	const { isUncancelable, onSetIsUncancelable } = useDayTripPlanIsUncancelable();

	return <Question isUncancelable={isUncancelable} onSetIsUncancelable={onSetIsUncancelable} />;
};

QuestionDayTripPlanIsUncancelable.displayName = "QuestionDayTripPlanIsUncancelable";
